export default function Sites() {
  return (
    <main>
<section className="sec tight">
    <div className="container">
      <p className="eyebrow">Shipped</p>
      <h2 className="title">Sites running <em>in the wild</em></h2>
      <p className="sub">Live client work, designed in Figma and built in WordPress, Elementor or React. Still online, still maintained.</p>
    </div>
  </section>
  <hr className="rule" />

  <section className="sec">
    <div className="container">
      <a className="site" href="https://benoitlondon.com/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">Benoit London</div><div className="sk">E-commerce · Fashion</div></div>
        <div className="sd">A WooCommerce store for a London luxury handbag label. Product catalogue, cart, wishlist, customer accounts, plus separate routes for the affiliate programme and wholesale partners so neither interrupts the retail journey.</div>
        <div className="sgo">benoitlondon.com ↗</div>
      </a>
      <a className="site" href="https://www.wearetavcorp.com/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">TavCorp</div><div className="sk">Agency · Commerce</div></div>
        <div className="sd">Company site and store designed end to end — every page, plus catalogue, cart, checkout, payment and the customer dashboard behind it.</div>
        <div className="sgo">wearetavcorp.com ↗</div>
      </a>
      <a className="site" href="https://teckafrica.org/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">TECK Africa</div><div className="sk">Nonprofit · WordPress</div></div>
        <div className="sd">Fourteen pages for a children's tech-education charity — four programme pages, three routes to get involved, events, blog and the donation flow. Designed and built.</div>
        <div className="sgo">teckafrica.org ↗</div>
      </a>
      <a className="site" href="https://www.americanelectrical.com/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">American Electrical</div><div className="sk">Business · WordPress</div></div>
        <div className="sd">Corporate site for an electrical supplier — structured service pages, content-heavy and responsive throughout.</div>
        <div className="sgo">americanelectrical.com ↗</div>
      </a>
      <a className="site" href="https://tiagababy.com/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">Tiaga Baby</div><div className="sk">Business · WordPress</div></div>
        <div className="sd">Client site with custom design, mobile-first layout and navigation built to stay simple as the catalogue grows.</div>
        <div className="sgo">tiagababy.com ↗</div>
      </a>
      <a className="site" href="https://cutesaint.com/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">Cutesaint</div><div className="sk">Business · WordPress</div></div>
        <div className="sd">Clean, responsive business site with custom design and performance optimisation.</div>
        <div className="sgo">cutesaint.com ↗</div>
      </a>
      <a className="site" href="https://eazy-king-project.vercel.app/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">Eazy King Booking</div><div className="sk">Web app · React</div></div>
        <div className="sd">React ticket-booking application — component architecture, form state and a booking flow that stays short.</div>
        <div className="sgo">eazy-king-project.vercel.app ↗</div>
      </a>
      <a className="site" href="https://portfolio-demo-wordpress.netlify.app/" target="_blank" rel="noopener noreferrer">
        <div><div className="sn">Portfolio Demo</div><div className="sk">WordPress · Custom theme</div></div>
        <div className="sd">WordPress portfolio demo with custom theming, built to show design and build capability in one place.</div>
        <div className="sgo">portfolio-demo-wordpress.netlify.app ↗</div>
      </a>
    </div>
  </section>
    </main>
  );
}
